import {
  connectRouter,
  routerMiddleware,
} from 'connected-react-router';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import {
  applyMiddleware,
  createStore,
} from 'redux';
import thunkMiddleware from 'redux-thunk';

import {
    AudiostoreAPI,
    SubtitlesAPI,
} from './api';
import { history } from './history';
import { rootReducer } from './reducers';
import {
  authStateChanged,
  listClips,
  uploadFile,
} from './thunks';

export function newStore() {
    const fbConfigJS = process.env.REACT_APP_FIREBASE_CONFIG || btoa('{}');
    const fbConfig = JSON.parse(atob(fbConfigJS));
    const app = firebase.initializeApp(fbConfig);

    const authFunc = async (): Promise<string | null> => {
      const user = app.auth().currentUser;
      if (!user) {
        return null;
      }
      const token = await user.getIdToken();
      return token;
    }

    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5100';
    const AUDIOSTORE_URL = process.env.REACT_APP_AUDIOSTORE_URL || 'http://localhost:8080';

    const audiostore = new AudiostoreAPI(AUDIOSTORE_URL, authFunc);
    const subtitles = new SubtitlesAPI(API_URL, authFunc);
    const store = createStore(
      connectRouter(history)(rootReducer),
      applyMiddleware(
        routerMiddleware(history),
        thunkMiddleware.withExtraArgument({
          audiostore,
          firebase: app,
          subtitles,
        })
      ));
    
    app.auth().onAuthStateChanged(user => store.dispatch(authStateChanged(user)));

    store.dispatch(listClips());

    const uploadNextFile = async () => {
        const {uploads} = store.getState();

        const remaining = uploads.queue
            .map(id => uploads.data[id])
            .filter(u => u.state === 'waiting');
    
        if (remaining.length === 0) {
            setTimeout(uploadNextFile, 1000);
            return;
        }
    
        const nextFile = remaining[0];
        await store.dispatch(uploadFile(nextFile));

        setTimeout(uploadNextFile, 0);
    }
    uploadNextFile();

    return store;
}

export default newStore;



// WEBPACK FOOTER //
// ./src/store.ts